export default __webpack_public_path__ + "static/media/logo_mapa_sa.9c0ee567.png";